import { tap, of, map } from "rxjs";
import { Injectable, signal } from "@angular/core";

import { User, UserPayload } from "../../interfaces";

import { GetPagedBody, HttpService, HttpServiceBaseCRUD } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class UsersService extends HttpService implements HttpServiceBaseCRUD {
  protected get baseUrl(): string {
    return "users/";
  }

  currentUser = signal<User | null>(null);

  add(body: UserPayload) {
    return this.post<User>({ APIName: "add", body, showAlert: true });
  }

  update(body: UserPayload) {
    return this.put<User>({ APIName: "update", body, showAlert: true });
  }

  updateProfile(body: UserPayload) {
    return this.put<User>({ APIName: "update-profile", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    if (!id) return of(null);
    return this.get<User | null>({ APIName: `get/${id}` });
  }

  getPaged(body: GetPagedBody<Record<string, string | number | boolean>>) {
    return this.getPagedRequest<User[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<User[]>({ APIName: "getall" });
  }

  getAllUsersAsUsernames() {
    return this.getAll().pipe(map((users) => users.map((user) => ({ id: user.id, nameEn: user.userName, nameAr: user.nameAr }))));
  }

  getUserRoles(userId: string) {
    return this.get<User[]>({ APIName: `GetUserRoles/${userId}` });
  }

  getUserPermissions(userId: string) {
    return this.get<any[]>({ APIName: `GetUserPermissions/${userId}` });
  }

  deleteSoft(id: string) {
    return this.delete({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getCurrentUser(id: string) {
    if (!id) return of(null);
    return this.get<User | null>({ APIName: `get/${id}` }).pipe(tap((res) => this.currentUser.set(res)));
  }

  getallbyfilter(body: any) {
    return this.post<User[]>({ APIName: "getallbyfilter", body });
  }
}
